// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sacolao-search-wrap {
  position: relative;
}

.sacolao-search-results {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 400px;
  overflow: auto;
  border-radius: 6px;
  border: 1px solid var(--ui-border);
  background: var(--ui-surface);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 20;
}

.sacolao-search-results > div {
  border-radius: 0;
  padding: 6px 10px;
  background-color: #fff;
  cursor: pointer;
}

.sacolao-search-results > div + div {
  border-top: 1px solid var(--ui-border);
}

.sacolao-search-result-item:hover {
  background: #f7faff;
}

.sacolao-field-label {
  display: block;
  margin: 0 0 6px 4px;
  font-size: 12px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
  letter-spacing: .3px;
}

.sacolao-field-help {
  display: block;
  margin-top: 6px;
  margin-left: 4px;
  font-size: 12px;
  color: var(--ui-muted);
}

.sacolao-visitor-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
}

.sacolao-visitor-status.status-liberado {
  color: #0a7a55;
  background: #dff8ee;
  border: 1px solid #b6edd9;
}

.sacolao-visitor-status.status-nao-liberado {
  color: #7a5b00;
  background: #fff7d8;
  border: 1px solid #efd98a;
}

.sacolao-visitor-status.status-bloqueado {
  color: #8f1d1d;
  background: #ffe1e1;
  border: 1px solid #f4b6b6;
}

.sacolao-filters-bar {
  display: grid;
  grid-template-columns: minmax(220px, 2fr) minmax(220px, 2fr) repeat(2, minmax(140px, 1fr)) minmax(140px, auto);
  gap: 10px;
  align-items: end;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  padding: 12px 14px;
  margin-bottom: 14px;
  box-shadow: var(--ui-shadow-sm);
}

.sacolao-filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.sacolao-filter-item label {
  font-size: 11px;
  font-weight: 700;
  color: var(--ui-muted);
  text-transform: uppercase;
  letter-spacing: .3px;
  line-height: 1;
  margin-left: 2px;
}

.sacolao-filter-actions {
  display: flex;
  align-items: end;
}

.sacolao-filter-actions button {
  width: 100%;
  justify-content: center;
  margin: 0;
}

@media (max-width: 1100px) {
  .sacolao-filters-bar {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }

  .sacolao-filter-actions {
    grid-column: 1 / -1;
  }
}

@media (max-width: 640px) {
  .sacolao-filters-bar {
    grid-template-columns: 1fr;
  }
}

.sacolao-observation-cell {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 220px;
  max-width: 360px;
  font-size: 13px;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Sacolao/sacolao.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8GAA8G;EAC9G,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".sacolao-search-wrap {\n  position: relative;\n}\n\n.sacolao-search-results {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  max-height: 400px;\n  overflow: auto;\n  border-radius: 6px;\n  border: 1px solid var(--ui-border);\n  background: var(--ui-surface);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  z-index: 20;\n}\n\n.sacolao-search-results > div {\n  border-radius: 0;\n  padding: 6px 10px;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.sacolao-search-results > div + div {\n  border-top: 1px solid var(--ui-border);\n}\n\n.sacolao-search-result-item:hover {\n  background: #f7faff;\n}\n\n.sacolao-field-label {\n  display: block;\n  margin: 0 0 6px 4px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  letter-spacing: .3px;\n}\n\n.sacolao-field-help {\n  display: block;\n  margin-top: 6px;\n  margin-left: 4px;\n  font-size: 12px;\n  color: var(--ui-muted);\n}\n\n.sacolao-visitor-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.sacolao-visitor-status.status-liberado {\n  color: #0a7a55;\n  background: #dff8ee;\n  border: 1px solid #b6edd9;\n}\n\n.sacolao-visitor-status.status-nao-liberado {\n  color: #7a5b00;\n  background: #fff7d8;\n  border: 1px solid #efd98a;\n}\n\n.sacolao-visitor-status.status-bloqueado {\n  color: #8f1d1d;\n  background: #ffe1e1;\n  border: 1px solid #f4b6b6;\n}\n\n.sacolao-filters-bar {\n  display: grid;\n  grid-template-columns: minmax(220px, 2fr) minmax(220px, 2fr) repeat(2, minmax(140px, 1fr)) minmax(140px, auto);\n  gap: 10px;\n  align-items: end;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  padding: 12px 14px;\n  margin-bottom: 14px;\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.sacolao-filter-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.sacolao-filter-item label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--ui-muted);\n  text-transform: uppercase;\n  letter-spacing: .3px;\n  line-height: 1;\n  margin-left: 2px;\n}\n\n.sacolao-filter-actions {\n  display: flex;\n  align-items: end;\n}\n\n.sacolao-filter-actions button {\n  width: 100%;\n  justify-content: center;\n  margin: 0;\n}\n\n@media (max-width: 1100px) {\n  .sacolao-filters-bar {\n    grid-template-columns: repeat(2, minmax(180px, 1fr));\n  }\n\n  .sacolao-filter-actions {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 640px) {\n  .sacolao-filters-bar {\n    grid-template-columns: 1fr;\n  }\n}\n\n.sacolao-observation-cell {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  min-width: 220px;\n  max-width: 360px;\n  font-size: 13px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
